import { TableCell, TableHead, TableRow } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { HeadCell } from '../../../../../types'

const headCellsOrders: HeadCell[] = [
  {
    id: 'name',
    numeric: false,
    label: 'name',
  },
  {
    id: 'type',
    numeric: false,
    label: 'type',
  },
  {
    id: 'numberOfOrders',
    numeric: true,
    label: 'number-of-orders',
  },
  {
    id: 'revenue',
    numeric: true,
    label: 'revenue',
  },
]

const CustomersResellersTableHeads = () => (
  <TableHead>
    <TableRow>
      {headCellsOrders?.map((headCell) => (
        <TableCell
          key={headCell.id}
          align="left"
          padding={headCell.disablePadding ? 'none' : 'normal'}
          sx={{
            fontSize: '18px !important',
          }}
        >
          <FormattedMessage id={headCell.label} />
        </TableCell>
      ))}
      <TableCell />
    </TableRow>
  </TableHead>
)

export default CustomersResellersTableHeads
